"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _DesignComponents = require("../DesignComponents/DesignComponents");
var _drag_indicator_light_blue_icon = _interopRequireDefault(require("../assets/drag_indicator_light_blue_icon.png"));
var _drag_indicator_dark_blue_icon = _interopRequireDefault(require("../assets/drag_indicator_dark_blue_icon.png"));
var _drag_indicator_very_dark_icon = _interopRequireDefault(require("../assets/drag_indicator_very_dark_icon.png"));
var _drag_indicator_drag_light_blue_icon = _interopRequireDefault(require("../assets/drag_indicator_drag_light_blue_icon.png"));
var _react = _interopRequireWildcard(require("react"));
var DropdownOptions = function DropdownOptions(categories, currentOption, stateOptions) {
  var dropdownOptions = [];
  for (var i = 0; i < categories.length; ++i) {
    dropdownOptions.push( /*#__PURE__*/_react.default.createElement(_DesignComponents.Dropdown.Option, {
      id: "dropdown-option-".concat(currentOption, "-").concat(i),
      key: i,
      value: "".concat(i),
      label: categories[i]
    }));
  }
  return dropdownOptions;
};
var prevTime;
var SortOption = /*#__PURE__*/(0, _react.memo)(function SortOption(props) {
  var completed = props.completed,
    optionName = props.optionName,
    optionK = props.optionK,
    categories = props.categories,
    stateOptions = props.stateOptions,
    optionContainerOnChange = props.optionContainerOnChange,
    preview = props.preview,
    dropdownState = props.dropdownState,
    setDropdownState = props.setDropdownState,
    focusState = props.focusState,
    setFocusState = props.setFocusState,
    isTouchDevice = props.isTouchDevice;
  var unsorted = stateOptions[optionK].currentCategory === -1;
  var category = document.getElementById("category-container-0");
  var dropdownWidth = "";
  if (category) {
    dropdownWidth = "".concat(category.offsetWidth * .5, "px");
  }
  var buttonContents = unsorted ? /*#__PURE__*/_react.default.createElement("div", {
    className: "dropdown-inner-text"
  }, "Category Selection") : /*#__PURE__*/_react.default.createElement("div", {
    className: "sorted-category-dropdown-text",
    style: {
      width: dropdownWidth
    }
  }, categories[stateOptions[optionK].currentCategory]);
  var backgroundColor = unsorted ? "#e9f7f7" : "#f2f5f8";
  var headerColor = null;
  var DragIcon = null;
  if (unsorted) {
    if (preview) {
      DragIcon = /*#__PURE__*/_react.default.createElement("img", {
        className: "drag-icon",
        alt: "",
        src: _drag_indicator_drag_light_blue_icon.default
      });
      headerColor = "#76cbcc";
    } else {
      DragIcon = /*#__PURE__*/_react.default.createElement("img", {
        className: "drag-icon",
        alt: "",
        src: _drag_indicator_light_blue_icon.default
      });
      headerColor = "#abe0e0";
    }
  } else {
    if (preview) {
      DragIcon = /*#__PURE__*/_react.default.createElement("img", {
        className: "drag-icon",
        alt: "",
        src: _drag_indicator_very_dark_icon.default
      });
      headerColor = "#32475e";
    } else {
      DragIcon = /*#__PURE__*/_react.default.createElement("img", {
        className: "drag-icon",
        alt: "",
        src: _drag_indicator_dark_blue_icon.default
      });
      headerColor = "#63768a";
    }
  }
  var handleChange = function handleChange(event) {
    setDropdownState(optionK, false);
    var newCategory = parseInt(event.value);
    if (stateOptions[optionK].currentCategory === newCategory) {
      return;
    }
    optionContainerOnChange(newCategory, optionK, stateOptions[optionK].currentCategory);
    prevTime = new Date();
    setFocusState(optionK); // activate focus
  };

  return /*#__PURE__*/_react.default.createElement("div", {
    key: optionK,
    className: !preview ? unsorted ? "answer-option-unsorted" : "answer-option-sorted" : "" // preview should not contain extra margin
    ,
    style: {
      cursor: !completed && !dropdownState ? 'move' : '',
      backgroundColor: backgroundColor,
      borderRadius: "3px"
    }
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "answer-option-header",
    style: {
      backgroundColor: headerColor
    }
  }, DragIcon), /*#__PURE__*/_react.default.createElement(_DesignComponents.Dropdown, {
    disabled: completed,
    key: optionK,
    label: optionName,
    id: "option-dropdown-".concat(optionK),
    buttonId: "option-dropdown-button-".concat(optionK),
    className: "answer-option-dropdown",
    buttonWidth: "100%",
    matchWidth: "button",
    buttonContents: buttonContents,
    onChange: handleChange,
    selected: stateOptions[optionK].currentCategory.toString(),
    closeOnExternalClick: true,
    isOpen: dropdownState,
    onRequestOpen: function onRequestOpen() {
      setTimeout(function () {
        if (!unsorted) {
          var _document$getElementB;
          var dropdownElement = (_document$getElementB = document.getElementById("option-dropdown-0-listbox")) === null || _document$getElementB === void 0 ? void 0 : _document$getElementB.parentElement;
          if (dropdownElement && dropdownElement.style.width !== "" && !isTouchDevice) {
            dropdownElement.style.width = "".concat(parseInt(dropdownElement.style.width) + 20, "px");
          }
        }
      }, 10);
      var currTime = new Date();
      if (currTime - prevTime < 100) {
        // prevent dropdown menu from opening on keyboard select
        return;
      }
      setDropdownState(optionK, true);
    },
    onRequestClose: function onRequestClose() {
      setDropdownState(optionK, false);
    }
  }, DropdownOptions(categories, optionK, stateOptions)));
});
var _default = SortOption;
exports.default = _default;